import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LoopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"loop"}/>
}
